import { useState } from "react";
import { exportTable } from "@/lib/exporter";
import { useToast } from "./Toast";

export function ExportBtns({ id, spec }) {
  const [busy, setBusy] = useState(null);
  const toast = useToast();
  const go = async fmt => {
    setBusy(fmt);
    try { await exportTable(spec(), fmt, toast); } finally { setBusy(null); }
  };
  const btn = (fmt, label) => (
    <button className="btn xbtn" data-x={id} data-fmt={fmt} data-testid={`${id}-export-${fmt}`} disabled={busy === fmt} onClick={() => go(fmt)}>
      {busy === fmt ? "Preparing…" : label}
    </button>
  );
  return <div className="xbtns" role="group" aria-label="Export data">{btn("xlsx", "Export to Excel")}{btn("csv", "Export CSV")}</div>;
}
